import { render } from "./PerformanceSummaryReport.vue?vue&type=template&id=4b912e7f&ts=true"
import script from "./PerformanceSummaryReport.vue?vue&type=script&lang=ts"
export * from "./PerformanceSummaryReport.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__